/**
 * @file スタディ面のアイコン (絵文字)。
 *
 * @what: 領域・考査の種類・用意するものの区分に 1 絵文字ずつ割り当てる。
 * @why: 文字が多い印象を絵で薄める (代表 2026-08-20)。アイコンは常にテキストラベルか
 *   title (tooltip) と併用し、絵文字だけで意味を持たせない。
 * @failure: 未定義の id は undefined (呼び出し側はアイコン無しで描画する)。
 */

import type { PreparationKind } from "../model";

/** 領域のアイコン (domainColors と同じ id で引く)。 */
export const DOMAIN_ICONS: Record<string, string> = {
  fine_motor: "✏️",
  craft: "✂️",
  shape_space: "🔷",
  number: "🔢",
  language: "💬",
  listening_memory: "👂",
  reasoning_knowledge: "🧩",
  body: "🏃",
  social_communication: "🤝",
};

/** 考査の種類のアイコン (attainment model の assessments カタログの id で引く)。 */
export const ASSESSMENT_ICONS: Record<string, string> = {
  paper: "📝",
  individual: "🎤",
  art_craft: "🎨",
  behavior: "👥",
  motor: "⚽",
  interview: "🙋",
};

/** 用意するものの区分のアイコン。 */
export const PREPARATION_KIND_ICONS: Record<PreparationKind, string> = {
  material: "📘",
  tool: "🧰",
  environment: "🏠",
};
